export default __webpack_public_path__ + "2b70bdc9283f4a8a76906590a8f8cbe2.webp";